import { Modal } from "react-bootstrap";
import "../../../CommonCss/ModalCommonCss.css";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../../../../utils/context";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import ModalSave from "../../../../common/ModalSave";
import AddedLottieModal from "../../../commonLottie/AddedLottieModal";
import { CancelButton } from "../../../../common/Button";

const AddModal = (props) => {
  const [showLottie, setShowLottie] = useState({ show: false, msg: "", success: false });
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await postData(`/hrms/device-control`, data);
     
      if (response?.success) {
        setShowLottie({ show: true, msg: response?.message, success: response?.success });
        reset();
      } else {
        setShowLottie({ show: true, msg: response?.message, success: response?.success });
      }
      setTimeout(() => {
        setShowLottie({ show: false, msg: "", success: false });
        props.onHide();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="modal-common-class-hrms">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="add-modal"
      >
        <Modal.Body>
          <div className="text-center">
            <h4 className="modal-title-common">Add Asset</h4>
          </div>

          <Container>
            <Row>
              <Col md={12}>
                <Container>

                  <Form onSubmit={handleSubmit(onSubmit)} role="form">
                    <Row>
                      <Col lg={8} md={10} className="mx-auto Add-content">
                        <div className="main-form-section mt-5">
                          <Form.Label>User Name</Form.Label>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <InputGroup>
                              <Form.Control
                                type="text"
                                name="UserName"
                                placeholder="User Name"
                                className={classNames("", {
                                  "is-invalid": errors?.UserName,
                                })}
                                {...register("UserName", {
                                  required: "User Name is required",
                                  validate: (value) => {
                                    if (value.includes(" ")) {
                                      return "Spaces are not allowed";
                                    }
                                    return true;
                                  },
                                })}
                                onKeyDown={(e) => {
                                  // Prevent space key
                                  if (e.key === " ") {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </InputGroup>

                            {errors.UserName && (
                              <span className="text-danger">
                                {errors.UserName.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="main-form-section mt-5">
                          <Form.Label>User Password</Form.Label>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <InputGroup>
                              <Form.Control
                                type="text"
                                name="UserPassword"
                                placeholder="User Password"
                                className={classNames("", {
                                  "is-invalid": errors?.UserPassword,
                                })}
                                {...register("UserPassword", {
                                  required: "User Password is required",
                                  validate: (value) => {
                                    if (value.includes(" ")) {
                                      return "Spaces are not allowed";
                                    }
                                    return true;
                                  },
                                })}
                                onKeyDown={(e) => {
                                  // Prevent space key
                                  if (e.key === " ") {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </InputGroup>
                            {errors.UserPassword && (
                              <span className="text-danger">
                                {errors.UserPassword.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="main-form-section mt-5">
                          <Form.Label>Device Serial No.</Form.Label>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <InputGroup>
                              <Form.Control
                                type="text"
                                name="SerialNumber"
                                placeholder="Device Serial No."
                                className={classNames("", {
                                  "is-invalid": errors?.SerialNumber,
                                })}
                                {...register("SerialNumber", {
                                  required: "Device Serial No is required",
                                  validate: (value) => {
                                    if (value.includes(" ")) {
                                      return "Spaces are not allowed";
                                    }
                                    return true;
                                  },
                                })}
                                onKeyDown={(e) => {
                                  // Prevent space key
                                  if (e.key === " ") {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  e.target.value = e.target.value.toUpperCase(); // Convert input to uppercase
                                }}
                              />
                            </InputGroup>
                            {errors.SerialNumber && (
                              <span className="text-danger">
                                {errors.SerialNumber.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="d-flex justify-content-center mt-5 pb-3">
                          <CancelButton
                            name="cancel"
                            handleClose={() => {
                              props.handleClose();
                              reset();
                            }}
                          />
                          <button type="submit" className="save-button">
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>

                </Container>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      <AddedLottieModal
        pageTitle="Designation"
        message={showLottie.msg}
        show={showLottie.show}
        success={showLottie.success}
        onHide={() => setShowLottie({ show: false, msg: "", success: false })}
      />
    </section>
  );
};

export default AddModal;
